speedDial-removed!
<!--<eco-fab-speed-dial animationMode="scale">-->
<!--	<eco-fab-speed-dial-trigger>-->
<!--		<ms-button mat-fab icon="fal fa-paperclip" variant="text" [title]="title"></ms-button>-->
<!--	</eco-fab-speed-dial-trigger>-->
<!--	<eco-fab-speed-dial-actions>-->
<!--		<button-->
<!--			mat-mini-fab-->
<!--			*ngFor="let item of _items"-->
<!--			(click)="item.onClick()"-->
<!--			class="hover:rounded-lg">-->
<!--			<div class="flex flex-row">-->
<!--				<i [class]="item.icon"></i>-->
<!--				<span-->
<!--					class="absolute whitespace-nowrap bg-gray-500 border px-2 py-1 left-11 bottom-2 rounded-lg"-->
<!--					>{{ item.title }}</span-->
<!--				>-->
<!--			</div>-->
<!--		</button>-->
<!--	</eco-fab-speed-dial-actions>-->
<!--</eco-fab-speed-dial>-->
